/**
 * @generated SignedSource<<523f111c5ae801afffa72ab8314b45fc>>
 * @relayHash 9648d887c0dfab09b49c2a3f48ea903a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d684c2c198ff6bc1b85a33c157bd7d2c7dd8bf2fbd19009d3f874178500e289d

import type { ConcreteRequest } from 'relay-runtime';
export type TemplateListUserQuery$variables = Record<PropertyKey, never>;
export type TemplateListUserQuery$data = {
  readonly user: {
    readonly id: string | null;
    readonly team: string | null;
  } | null;
};
export type TemplateListUserQuery = {
  response: TemplateListUserQuery$data;
  variables: TemplateListUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "team"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TemplateListUserQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TemplateListUserQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9648d887c0dfab09b49c2a3f48ea903a",
    "id": "d684c2c198ff6bc1b85a33c157bd7d2c7dd8bf2fbd19009d3f874178500e289d",
    "metadata": {},
    "name": "TemplateListUserQuery",
    "operationKind": "query",
    "text": "query TemplateListUserQuery{user:confluence_atlassianUser{id,team}}"
  }
};
})();

(node as any).hash = "1379dbc141731554e24df5addf57d64c";

export default node;
